
import React, { useEffect, useRef } from 'react';
import { Location } from '../types/maps';
import { MapPin } from 'lucide-react';
import { loader } from '../utils/googleMapsLoader';

interface LocationInputProps {
  label: string;
  value: string;
  onChange: (location: Location) => void;
}

const LocationInput: React.FC<LocationInputProps> = ({ label, value, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

  useEffect(() => {
    loader.load().then(() => {
      if (inputRef.current && !autocompleteRef.current) {
        autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, {
          componentRestrictions: { country: 'BE' },
          fields: ['address_components', 'geometry', 'formatted_address'],
        });

        autocompleteRef.current.addListener('place_changed', () => {
          const place = autocompleteRef.current?.getPlace();
          if (place?.geometry?.location) {
            onChange({
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address || '',
            });
          }
        });
      }
    }).catch((error) => {
      console.error('Error loading Google Maps:', error);
    });
  }, [onChange]);

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MapPin className="h-5 w-5 text-gray-400" />
      </div>
      <input
        ref={inputRef}
        type="text"
        defaultValue={value}
        placeholder={label}
        className="block w-full pl-10 pr-3 py-3 bg-white/90 border border-gray-300 rounded-lg leading-5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
      />
    </div>
  );
};

export default LocationInput;
